import { combineReducers } from 'redux';
import {
  LIBRARY_TAXES_SET_LIST_TAXES,
  LIBRARY_TAXES_SET_OUTLETS,
  LIBRARY_TAXES_SET_CURRENT_PAGE,
  LIBRARY_TAXES_SET_TOTAL_PAGE,
  LIBRARY_TAXES_SET_TAX_DETAIL,
  LIBRARY_TAXES_SET_DELETED_TAX,
  LIBRARY_TAXES_SHOW_DELETE_MODAL,
  LIBRARY_TAXES_HIDE_DELETE_MODAL,
  LIBRARY_TAXES_OPEN_RIGHT_COLUMN,
  LIBRARY_TAXES_CLOSE_RIGHT_COLUMN,
  LIBRARY_TAXES_IS_SUBMITTING_FORM,
} from 'actions/library/tax/constants';

import createReducer from 'utils/createReducer';

const currentPage = createReducer(null, {
  [LIBRARY_TAXES_SET_CURRENT_PAGE]: (draft, { payload }) => payload.currentPage,
});

const deletedTax = createReducer(null, {
  [LIBRARY_TAXES_SET_DELETED_TAX]: (draft, { payload }) => payload.deletedTax,
});

const isSubmittingForm = createReducer(false, {
  [LIBRARY_TAXES_IS_SUBMITTING_FORM]: (draft, { payload }) =>
    payload.isSubmittingForm,
});

const openRightColumn = createReducer(false, {
  [LIBRARY_TAXES_OPEN_RIGHT_COLUMN]: () => true,
  [LIBRARY_TAXES_CLOSE_RIGHT_COLUMN]: () => false,
});

const outlets = createReducer([], {
  [LIBRARY_TAXES_SET_OUTLETS]: (draft, { payload }) => payload.outlets,
});

const showDeleteModal = createReducer(false, {
  [LIBRARY_TAXES_SHOW_DELETE_MODAL]: () => true,
  [LIBRARY_TAXES_HIDE_DELETE_MODAL]: () => false,
});

const taxDetail = createReducer(null, {
  [LIBRARY_TAXES_SET_TAX_DETAIL]: (draft, { payload }) => payload.tax,
});

const taxes = createReducer([], {
  [LIBRARY_TAXES_SET_LIST_TAXES]: (draft, { payload }) => payload.taxes,
});

const totalPage = createReducer(null, {
  [LIBRARY_TAXES_SET_TOTAL_PAGE]: (draft, { payload }) => payload.totalPage,
});

export default combineReducers({
  currentPage,
  deletedTax,
  isSubmittingForm,
  openRightColumn,
  outlets,
  showDeleteModal,
  taxDetail,
  taxes,
  totalPage,
});
